import { defineMessages } from "react-intl";

export const messages = defineMessages({
  title: {
    id: "hewNP0",
    defaultMessage: "Catalog",
    description: "wizard step title",
  },
  description: {
    id: '3C2y2F',
    defaultMessage: "Set up your brands to organize your products.",
    description: "wizard step description",
  },
  productTypesTab: {
    id: 'wCTX5H',
    defaultMessage: "Brands",
    description: "catalog step tab label",
  },
  // Categories and Products tabs removed per Issue #70
  nameColumn: {
    id: "4DPchc",
    defaultMessage: "Name",
    description: "table column header",
  },
  shippableColumn: {
    id: "dL2LSk",
    defaultMessage: "Shippable",
    description: "table column header",
  },
  // Category and Product related messages removed per Issue #70
  addProductType: {
    id: 'Ub7m7Z',
    defaultMessage: "Add Brand",
    description: "add button label",
  },
  // Add Category and Add Product removed per Issue #70
  emptyProductTypes: {
    id: 'vRQPMW',
    defaultMessage: "No brands yet. Add one to get started.",
    description: "empty state message",
  },
  // Empty states for categories and products removed per Issue #70
  yes: {
    id: "5Ofhx7",
    defaultMessage: "Yes",
    description: "boolean yes",
  },
  no: {
    id: "NL3Kxx",
    defaultMessage: "No",
    description: "boolean no",
  },
  cancel: {
    id: "uT5L4h",
    defaultMessage: "Cancel",
    description: "cancel button label",
  },
  save: {
    id: "9xwH9i",
    defaultMessage: "Save",
    description: "save button label",
  },
  productTypeName: {
    id: 'a0I/eE',
    defaultMessage: "Brand Name",
    description: "form field label",
  },
  isShippingRequired: {
    id: "97TZvj",
    defaultMessage: "This is a physical product that requires shipping",
    description: "form field label",
  },
  // Category and product form fields removed per Issue #70
  productType: {
    id: 'eYQmur',
    defaultMessage: "Brand",
    description: "form field label",
  },
  productTypeCreated: {
    id: 'Miwr9x',
    defaultMessage: "Brand created",
    description: "success notification",
  },
  // Category and product creation messages removed per Issue #70
  createError: {
    id: "Q4EewX",
    defaultMessage: "Something went wrong. Please try again.",
    description: "generic error notification",
  },
  nameRequired: {
    id: "1zhggq",
    defaultMessage: "Name is required",
    description: "validation error",
  },
  productTypeRequired: {
    id: 'mnoDU9',
    defaultMessage: "Brand is required",
    description: "validation error",
  },
  deleteConfirmTitle: {
    id: '9Lv9FB',
    defaultMessage: "Confirm Deletion",
    description: "delete confirmation dialog title",
  },
  deleteConfirmProductType: {
    id: '70+3Lf',
    defaultMessage: "Are you sure you want to delete this brand?",
    description: "delete confirmation dialog body",
  },
  // Category and product delete confirmations removed per Issue #70
  productTypeDeleted: {
    id: 'I8Zhpc',
    defaultMessage: "Brand deleted",
    description: "success notification",
  },
  // Category and product deletion messages removed per Issue #70
  deleteError: {
    id: 'iQrDI2',
    defaultMessage: "Failed to delete. Please try again.",
    description: "delete error notification",
  },
});
